export const IDLE_TIMEOUT_MS = 60 * 60 * 1000;
export const ACTIVITY_THROTTLE_MS = 15 * 1000;
export const LAST_ACTIVITY_KEY = 'ridespot_last_activity';

type StorageLike = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

export function readLastActivity(storage: Pick<StorageLike, 'getItem'> = window.localStorage): number | null {
  const raw = storage.getItem(LAST_ACTIVITY_KEY);
  if (!raw) return null;
  const parsed = Number(raw);
  return Number.isFinite(parsed) ? parsed : null;
}

export function writeLastActivity(
  timestamp = Date.now(),
  storage: Pick<StorageLike, 'setItem'> = window.localStorage
): number {
  storage.setItem(LAST_ACTIVITY_KEY, String(timestamp));
  return timestamp;
}

export function clearLastActivity(storage: Pick<StorageLike, 'removeItem'> = window.localStorage): void {
  storage.removeItem(LAST_ACTIVITY_KEY);
}

export function hasIdleSessionExpired(lastActivity: number | null, now = Date.now()): boolean {
  return lastActivity != null && now - lastActivity >= IDLE_TIMEOUT_MS;
}
